export default __webpack_public_path__ + "static/media/ic_trading.2c53815a.svg";